function escapeHtml(value) {
    const entities = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    return String(value == null ? '' : value).replace(/[&<>"']/g, (character) => entities[character]);
}

// 医生、科普模块的堆叠图共用，过滤零值并防止长名称或大量系列撑出画布。
export function buildStackedTooltip() {
    return {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        renderMode: 'html',
        appendToBody: true,
        confine: true,
        enterable: true,
        extraCssText: 'max-width:500px;max-width:min(500px,calc(100vw - 24px));max-height:300px;overflow-y:auto;white-space:normal;overflow-wrap:anywhere;box-sizing:border-box;line-height:20px;',
        formatter(params) {
            const rows = (Array.isArray(params) ? params : [params]).filter((item) =>
                item && Number.isFinite(Number(item.value)) && Number(item.value) !== 0
            );
            if (!rows.length) return '';
            const first = rows[0];
            const title = first.axisValueLabel || first.axisValue || first.name;
            return `<div style="font-weight:600;margin-bottom:6px">${escapeHtml(title)}</div>` +
                rows.map((item) => `<div style="display:flex;align-items:flex-start;gap:12px;margin:4px 0">` +
                    `<span style="flex:1;min-width:0">${item.marker || ''}${escapeHtml(item.seriesName)}</span>` +
                    `<strong style="flex:none;white-space:nowrap">${escapeHtml(item.value)}</strong></div>`).join('');
        },
    };
}
